import React, { Component } from "react";
import "./index.scss";
import Story from "@/components/story";
import { connect } from "react-redux";
import { storeChangeObject, storeMenuType } from "@action";
import { srcPath, config } from "@utils/config";
import { recordEven } from "@/api/actions";
import VoiceControl from "@/components/voiceControl";
import "./index.scss";
class Home extends Component {
  state = {
    isLocalData: false,
    isShowWelcom: true,
    showStory: false,
    historyState: JSON.parse(localStorage.getItem("v"))
  };

  componentDidMount() {
    this.setState({
      isLocalData: !!localStorage.getItem("v"),
      historyState: JSON.parse(localStorage.getItem("v"))
    });
    if (!this.props.showWelcome) {
      this.setState({
        isShowWelcom: false
      });
    }
    this.props.onGetHome(this);
  }
  hideWelcome() {
    this.props.dispatch(
      storeChangeObject({
        showWelcome: false
      })
    );
    setTimeout(() => {
      this.setState({
        isShowWelcom: false
      });
    }, 1000);
    myVideo.play();
  }
  isShowStory(type) {
    if (type) {
      recordEven("背景故事");
    } else {
      recordEven("关闭背景故事");
    }
    audioBtn.play();
    this.setState({
      showStory: type
    });
  }
  // 开始播放正题
  beginPlayVideo() {
    localStorage.removeItem("v");
    this.state.historyState && this.state.historyState.choicesArr.length > 0
      ? recordEven("重新开始")
      : recordEven("点击开始");
    audioBtn.play();
    setTimeout(() => {
      this.props.dispatch(
        storeChangeObject({
          isShowMenu: true
        })
      );
      this.props.dispatch(storeMenuType(true));
    }, 1000);
    this.props.dispatch(
      storeChangeObject({
        isShowMenu: false,
        videoSrc: srcPath[config[1].path],
        videoData: config[1],
        pageTag: "index",
        choicesArr: []
      })
    );
  }
  backToResult(type) {
    if (type) {
      recordEven("返回");
    }
    audioBtn.play();
    this.props.dispatch(
      storeChangeObject({
        pageTag: "result"
      })
    );
  }
  continuePlayFn() {
    recordEven("继续");
    const historyState = JSON.parse(JSON.stringify(this.state.historyState));
    if (this.state.historyState.choicesArr.length == 5) {
      this.backToResult(false);
      this.props.dispatch(
        storeChangeObject({
          choicesArr: historyState.choicesArr
        })
      );
    } else {
      audioBtn.play();
      this.props.dispatch(
        storeChangeObject({
          choicesArr: historyState.choicesArr,
          videoSrc: historyState.videoSrc,
          videoData: historyState.videoData,
          pageTag: "index",
          homeType: "again",
          isShowMenu: false,
        })
      );
      setTimeout(() => {
        this.props.dispatch(
          storeChangeObject({
            isShowMenu: true
          })
        );
        this.props.dispatch(storeMenuType(true));
      }, 1000);
    }
  }
  render() {
    const { props, state } = this;
    return (
      <div className="b_box">
        {/* <VoiceControl /> */}
        {/* 欢迎页 */}
        {state.isShowWelcom && (
          <div
            className={`wh100 home_bg animated ${
              props.showWelcome ? "" : "fadeOut"
            }`}
            onClick={this.hideWelcome.bind(this)}
          >
            {props.isShowWelcomeIcon && (
              <img
                src={require("@img/loading_icon.gif")}
                className="loading_icon"
              ></img>
            )}
          </div>
        )}
        <div>
          {/* 背景故事 */}
          {state.showStory && (
            <Story
              nextTxt={
                state.historyState && state.historyState.choicesArr.length > 0
                  ? "继续"
                  : "点击开始"
              }
              nextFn={
                state.historyState && state.historyState.choicesArr.length > 0
                  ? this.continuePlayFn.bind(this)
                  : this.beginPlayVideo.bind(this)
              }
              isShowStory={this.isShowStory.bind(this, false)}
            />
          )}
          {/* 首页 */}
          <div className={`home_box ${state.showStory ? "dis_n" : ""}`}>
            <img
              src={require("@img/home_logo.png")}
              className="home_logo"
              alt=""
            />
            <img
              src={require("@img/home_title.png")}
              className="home_title"
              alt=""
            />
            <div className="foot_btn_box dis_f ali_ct jus_ct">
              {state.historyState &&
                state.historyState.choicesArr.length > 0 &&
                props.homeType == "again" && (
                  <div
                    className="foot_btn"
                    onClick={this.continuePlayFn.bind(this)}
                  >
                    <img
                      src={require("@img/btn_bg.png")}
                      className="btn_bg"
                    ></img>
                    <div className="foot_btn_txt cen">继续</div>
                  </div>
                )}
              <div
                className="foot_btn"
                onClick={this.beginPlayVideo.bind(this)}
              >
                <img src={require("@img/btn_bg.png")} className="btn_bg"></img>
                {state.historyState &&
                state.historyState.choicesArr.length > 0 ? (
                  <div className="foot_btn_txt cen">
                    重新
                    <br />
                    开始
                  </div>
                ) : (
                  <div className="foot_btn_txt cen">
                    点击
                    <br />
                    开始
                  </div>
                )}
              </div>
              <div
                className="foot_btn"
                onClick={this.isShowStory.bind(this, true)}
              >
                <img src={require("@img/btn_bg.png")} className="btn_bg"></img>
                <div className="foot_btn_txt cen">
                  背景
                  <br />
                  故事
                </div>
              </div>
              {(props.choicesArr.length == 5 ||
                (state.historyState &&
                  state.historyState.choicesArr.length > 5)) &&
                props.homeType == "result" && (
                  <div
                    className="foot_btn"
                    onClick={this.backToResult.bind(this)}
                  >
                    <img
                      src={require("@img/btn_bg.png")}
                      className="btn_bg"
                    ></img>
                    <div className="foot_btn_txt cen">返回</div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, null)(Home);
